import DocumentViewerModal from "components/DocumentViewer";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  AppealNormalFeedback,
  AppealNormalFeedbackActor,
  FILE_URL,
} from "types";
import { feedbackIcon } from "utils/constant";

type Props = {
  normal_feedbacks: AppealNormalFeedback[];
};

const AppealRespondbackFeedback: React.FC<Props> = ({ normal_feedbacks }) => {
  const { t } = useTranslation();

  return (
    <div className="ml-6">
      <h1 className="text-black font-semibold text-base flex flex-row gap-2">
        {feedbackIcon} {t("respond_back_feedback_section")}
      </h1>
      <div className="flex flex-col gap-4 mt-4 justify-between min-h-[50vh] w-full">
        <div className="flex flex-col overflow-y-auto gap-2">
          <div className="flex flex-col gap-4 mt-4 justify-between min-h-[50vh] w-full">
            {normal_feedbacks?.length === 0 && (
              <p className="text-gray-500 text-sm">
                {t("no_respond_back_feedbacks_available")}
              </p>
            )}
            <div className="flex flex-col gap-0 w-full">
              {normal_feedbacks?.map((feedback, index) => (
                <div
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                  } px-6 py-4 rounded-md shadow-sm mb-4`}
                  style={{
                    overflowWrap: "break-word",
                  }}
                >
                  <div className="flex justify-between items-center">
                    <p className="text-xs font-medium text-red-600">
                      {t("commented_date")}
                    </p>
                    <p className="text-xs text-gray-700">
                      {feedback?.created_at &&
                        new Date(feedback?.created_at).toLocaleString()}
                    </p>
                  </div>
                  <div className="flex items-center gap-2 mt-2">
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-gray-200 text-gray-600 text-xs font-bold">
                      {feedback?.actor === "PROSECUTOR" &&
                        t("role_prosecutor_short")}
                      {feedback?.actor === "REGISTRAR" &&
                        t("role_registrar_short")}
                      {feedback?.actor === "COORDINATOR" &&
                        t("role_coordinator_short")}
                      {feedback?.actor === "OTHER" && t("role_other_short")}
                    </span>
                    <span className="text-xs text-gray-700">
                      <span className="font-semibold text-gray-900">
                        {t("by")}:
                      </span>{" "}
                      {feedback?.actor &&
                        AppealNormalFeedbackActor[feedback?.actor]}
                    </span>
                  </div>
                  <div className="mt-3 flex flex-col gap-2">
                    <p className="text-sm text-gray-800 whitespace-pre-line">
                      {feedback?.feedback_text}
                    </p>

                    <DocumentViewerModal
                      documents={(feedback?.documents || []) as any}
                      baseUrl={`${process.env.REACT_APP_API_BASE_URL}${FILE_URL.APPEAL_RESPOND_BACK_FEEDBACK}`}
                      layout="list"
                      hideEmptyFile={true}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppealRespondbackFeedback;
